import React, { useState, useEffect } from "react";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function HeroBanner2() {
    const [dataSource, setDataSource] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const bannerSlides = dataSource?.filter(
        (slide) => slide.image_type === "Second Page Banner"
    ) || [];
    useEffect(() => {
        fetchBannersData();
    }, []);
    const fetchBannersData = async () => {
        try {
            let url = webEndPoint + "banners";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
            }
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % bannerSlides.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [bannerSlides.length]);
    return (
        <div className="hero2-container">
            {bannerSlides.map((slide, i) => (
                <div key={i} className={`hero2-slide ${i === currentIndex ? "active" : ""}`}>
                    <img src={slide.image_url} alt="banner" />
                </div>
            ))}
        </div>
    );
}